import React from "react";
import InformationCard from "./InformationCard";
import { faMicroscope, faCapsules, faHospital } from "@fortawesome/free-solid-svg-icons";
import "../Styles/Info.css";

function Info() {
  return (
    <div className="info-section" id="services">
      <div className="info-title-content">
        <h3 className="info-title">
          <span>Our Services</span>
        </h3>
        <p className="info-description">
          We provide easy access to nearby healthcare services, including lab test bookings and medicine orders. 
          Our goal is to make healthcare convenient by connecting you with trusted labs and pharmacies in your area.
        </p>
      </div>

      <div className="info-cards-content">
        <InformationCard
          title="Nearby Lab Bookings"
          description="Easily book lab tests at certified labs near you. Whether you need routine tests or specialized diagnostics, 
            our platform offers seamless appointment scheduling with trusted laboratories."
          icon={faMicroscope}
        />

        <InformationCard
          title="Medicine Orders"
          description="Order your medicines from verified pharmacies with just a few clicks. Our platform ensures fast delivery 
            of prescription and over-the-counter medicines, helping you stay on top of your health needs."
          icon={faCapsules}
        />

        <InformationCard
          title="Healthcare Centers"
          description="Find and book appointments at healthcare centers near you. From general consultations to specialized care, 
            we make it easy for you to access quality healthcare services in your vicinity."
          icon={faHospital}
        />
      </div>
    </div>
  );
}

export default Info;